import { voteMatchesFilter } from '../../helpers'
import type { VoteDetail } from '../../models'

/**
 * Filter vote details by choice filter and a text search string.
 * Search matches against legislator_name, last_name, and party (case-insensitive).
 *
 * Mirrors filters.rs filter_vote_details.
 */
export function filterVoteDetails(
  details: VoteDetail[],
  filter: string,
  search: string,
): VoteDetail[] {
  const needle = search.toLowerCase()
  return details.filter((detail) => {
    if (!voteMatchesFilter(detail.vote_choice, filter)) return false
    if (needle === '') return true
    if (detail.legislator_name.toLowerCase().includes(needle)) return true
    if (detail.last_name != null && detail.last_name.toLowerCase().includes(needle)) return true
    if (detail.party != null && detail.party.toLowerCase().includes(needle)) return true
    return false
  })
}
